'use strict';
import Barba from 'barba.js';
import Env from '../base/env.js';
import Channels from '../base/channels'
import RevealHome from '../fx/RevealHome.js';
import gsap from 'gsap'
import SplitText  from "../vendor/gsap-bonus-umd/SplitText";
gsap.registerPlugin(SplitText);
import lottie from 'lottie-web'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--home'
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    events()
    {
      this.view.querySelector('.wpcf7').addEventListener( 'wpcf7submit', ( event )=> {
        Env.framework.UI.refreshScroll()
      }, false );

      Channels.on('window::smartresize',()=>{
        this.introTxtSplitter.revert()
        this.checkSizer()
      })
    }

    form()
    {
      const $inputsTxt = this.view.querySelectorAll('.wpcf7-text')
      for(const $input of $inputsTxt) {
        const $dogtag = $input.parentElement.parentElement.querySelector('.dogtag')
        $input.addEventListener('focus',()=>{
          $dogtag.classList.add('is-active')
        })
        $input.addEventListener('blur',()=>{
          if($input.value.length == 0) {
            $dogtag.classList.remove('is-active')
          }

        })
      }
    }

    checkSizer()
    {
      const $sizer1 = this.view.querySelectorAll('.jsSizer1')
      const $sizer2 = this.view.querySelectorAll('.jsSizer2')
      // const $sizer3 = this.view.querySelectorAll('.jsSizer3')

      // Refresh
      for(let $size of $sizer1) {
        $size.style.height = `auto`
      }
      for(let $size of $sizer2) {
        $size.style.height = `auto`
      }
      // for(let $size of $sizer3) {
      //   $size.style.height = `auto`
      // }

      // Size 1
      let memoHeight = 0
      for(let $size of $sizer1) {
        const getHeight = $size.getBoundingClientRect().height
        if(getHeight > memoHeight) {
          memoHeight = getHeight
        }
      }
      for(let $size of $sizer1) {
        $size.style.height = `${memoHeight}px`
      }

      // Size 2
      memoHeight = 0
      for(let $size of $sizer2) {
        const getHeight = $size.getBoundingClientRect().height
        if(getHeight > memoHeight) {
          memoHeight = getHeight
        }
      }
      for(let $size of $sizer2) {
        $size.style.height = `${memoHeight}px`
      }

      // Size 3
      // memoHeight = 0
      // for(let $size of $sizer3) {
      //   const getHeight = $size.getBoundingClientRect().height
      //   if(getHeight > memoHeight) {
      //     memoHeight = getHeight
      //   }
      // }
      // for(let $size of $sizer3) {
      //   $size.style.height = `${memoHeight}px`
      // }
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
            this.events()
            this.checkSizer()
            this.form()
            this.fxHome = new RevealHome(this.view)
            this.fxHover()
            setTimeout(() => {
              this.goToAnchor()
            }, 100);



        }, 200);
    }

    fxHover()
    {
      const $btns = this.view.querySelectorAll('.fxHover')
      for(const $btn of $btns) {
        const $animationContainer = $btn.querySelector('.animation')
        const anim = lottie.loadAnimation({
          container: $animationContainer,
          renderer: 'svg',
          loop: false,
          autoplay: false,
          path: config.pathAssets+'/animation/lf30_editor_scom1uy1.json'
        });
        $btn.addEventListener('mouseenter',()=>{
          anim.setSpeed(1)
          anim.setDirection(1)
          anim.play()
        })
        $btn.addEventListener('mouseleave',()=>{
          anim.setSpeed(2)
          anim.setDirection(-1)
          anim.play()
        })
      }
    }

    goToAnchor()
    {
      const getHash = window.location.hash
      if(getHash.length) {
        const nameTarget = getHash+'-section'
        const $target = document.querySelector(nameTarget);
        const offset = (getHash == '#contact-us')?-130:0;
        Env.locoScroll.scrollTo($target, { offset:offset});
      }

    }

    intro()
    {
      const $intro = this.view.querySelector('.jsIntro')
      const $text = new SplitText($intro.querySelector('.fxText') , { type: 'lines'})
      this.introTxtSplitter = $text
      const $visuals = $intro.querySelectorAll('.fxVisual')
      const $logo = $intro.querySelector('.fxLogo')

      const tl = gsap.timeline()

      tl.add(()=>{
        gsap.set($intro.querySelector('.fxText') , { autoAlpha : 1})
      })
      tl.add([
        gsap.fromTo($logo , { autoAlpha : 0 , y : 20 } , { autoAlpha : 1 , y : 0, ease : 'power4.out' , duration:2 }),
        gsap.fromTo($text.lines , { autoAlpha : 0 , y : 20 } , { autoAlpha : 1 , y : 0, ease : 'power4.out' , duration:2 , stagger:.2 , delay : .1})
      ])
      tl.add([
        gsap.fromTo($visuals , { autoAlpha : 0 , y : 0 } , { autoAlpha : 1 , y : 0, ease : 'power4.out' , duration:4 , stagger:0}),
      ],'-=1.5')


    }
}

page = Barba.BaseView.extend({
    namespace: 'home',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;
